/**
 * English-only translation strings for the inlined events view.
 * The original (zagmuk) source kept a locale map; we dropped it.
 */

const translations = {
  page: 'Page: ',
  no_status: 'No result with applied filter',
  no_events_at_all: 'No import events recorded yet',
  no_events_matching_filter: 'No events match the current filters',
  started: 'Started',
  ended: 'Ended',
  duration: 'Duration: ',
  username: 'Username: ',
  show: 'Show',
  show_all: 'All',
  show_only_failed: 'Only failed',
  show_only_success: 'Only successful',
  show_only_cancelled: 'Only cancelled',
  filter_direct_delivery: 'Only started with file delivery',
  refresh: 'Refresh',
};

export default translations;
